import React from 'react';

import { Box, Stack, type SxProps, Typography } from '@mui/material';

import emptyIllustration from './empty.svg';

type Props = {
  caption: JsxNode | string;
  sx?: SxProps;
};

export function EmptyIllustration({ caption, sx = { py: 5 } }: Props) {
  function captionEl() {
    if (typeof caption === 'string') {
      return <Typography color="text.secondary">{caption}</Typography>;
    }
    return caption;
  }

  return (
    <Stack spacing={3} sx={sx} alignItems="center" justifyContent="center" textAlign="center" px={2}>
      <Box component="img" src={emptyIllustration} alt="No items" sx={{ maxWidth: 96 }} />
      {captionEl()}
    </Stack>
  );
}
